import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import { cn } from "@/app/utils/className";

export const BannerBlob = ({ className }: { className?: string }) => {
  const blobRef = useRef<HTMLImageElement>(null);
  useGSAP(() => {
    const blob = blobRef.current;

    if (!blob) return;

    // Set initial position to center the blob's center point
    gsap.set(blob, {
      xPercent: -50,
      yPercent: -50,
    });

    gsap.to(blob, {
      backgroundImage:
        "linear-gradient(360deg, var(--color-haizea-green) 0%, var(--color-haizea-blue) 100%)",
      repeat: -1,
      yoyo: true,
      duration: 10,
      ease: "power1.inOut",
    });
    const handleMouseMove = (e: MouseEvent) => {
      const { clientX, clientY } = e;

      // Position blob center exactly at cursor position
      gsap.to(blob, {
        left: clientX,
        top: clientY,
        duration: 6, // Increased lag for smoother following
        ease: "power2.out",
      });
    };

    // Add event listener
    window.addEventListener("mousemove", handleMouseMove);

    // Cleanup
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div
      ref={blobRef}
      className={cn(
        "gradient-blob absolute z-[0] pointer-events-none",
        className
      )}
    ></div>
  );
};
